import { IGetVillageListResponseSchema } from '../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { Action, ActionTypes } from './actions';

export function villageListReducer(
  state: IGetVillageListResponseSchema,
  action: Action,
): IGetVillageListResponseSchema {
  switch (action.type) {
    case ActionTypes.Fetched: {
      return { ...state, ...action.data };
    }
    case ActionTypes.MobileFetched: {
      const { villageList } = state;

      return {
        ...state,
        ...action.data,
        villageList: (villageList || []).concat(action.data.villageList || []),
      };
    }
    default: {
      return state || {};
    }
  }
}
